import { defineComponent } from "vue";
import useVuelidate from "@vuelidate/core";
import { integer, required } from "@vuelidate/validators";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css'
import { getCountries } from "@/utils/utils";
import { Quiz } from "@/model/quiz.model";
import quizService from "@/services/quiz.interface";
import routersManager from "@/managers/routers.manager";

export enum QuizType {
    INIT = "init",
    FINAL = "final"
}
const regex = /^\d{5}$/;
const postalCode = (value) => regex.test(value)

export default defineComponent({
    name: "QuizComponent",
    components: {
        'v-select': vSelect
    },
    props: ["type", "route", "location"],
    emits: ["back", "goTo"],
    setup() {
        return { v$: useVuelidate() };
    },
    data() {
        return {
            QuizType: QuizType,
            isSpanish: false,
            ageOptions: [
                "Menos de 18 años",
                "Entre 18 y 39 años",
                "Entre 40 y 54 años",
                "Entre 55 y 64 años",
                "Más de 65 años"
            ],
            groupOptions: [
                "Solo yo",
                "Familia",
                "Amigos",
                "Grupo o asociación Cultural",
                "Pareja"
            ],
            genderOptions: [
                "Mujer",
                "Hombre",
                "Otro"
            ],
            countries: getCountries(),
            isInvalid: true,
            age: null,
            groupType: null,
            groupNumber: null,
            gender: null,
            nationality: null,
            postalCode: null,
            prioritizedCountries: [
                "Alemania",
                "España",
                "Estados Unidos",
                "Francia",
                "Italia",
                "Reino Unido"
            ],
            points: null,
            item: null,
            locations: [],
            showFinal: false
        }
    },
    validations() {
        if (this.type == QuizType.INIT) {
            const localRules = {
                age: { required },
                groupType: { required },
                groupNumber: { required, integer },
                gender: { required },
                nationality: { required },
                postalCode: {}
            };
            if (this.isSpanish) {
                localRules["postalCode"] = { required, integer, postalCode };
            }
            return localRules;
        } else {
            const localRules = {
                points: { required },
                item: { required }
            }
            return localRules;
        }
    },
    async mounted() {
        if (this.type == QuizType.FINAL) {
            this.locations = 
                (await routersManager.getRoute(this.route)).locations.map(location => {return location.name});
        }
        
    },
    watch: {
        v$(v) {
            this.isInvalid = v.$invalid ;
        }
    },
    computed: {
        sortedCountries() {
            const compareCountries = (a, b) => {
                const indexA = this.prioritizedCountries.indexOf(a);
                const indexB = this.prioritizedCountries.indexOf(b);
    
                if (indexA !== -1 && indexB !== -1) {
                    return indexA - indexB;
                }
                if (indexA !== -1) {
                    return -1;
                }
                if (indexB !== -1) {
                    return 1;
                }
                return 0;
            };
    
            return [...this.countries].sort(compareCountries);
        }
    },
    methods: {
        goBack(): void {
            this.v$.$reset();
            this.$emit("back", false);
        },
        nationalitiyChange(value: string): void {
            this.isSpanish = value == "España";
        },
        groupTypeChange(value: string): void {
            if (value == this.groupOptions[0]) {
                this.groupNumber = 1;
            } else if ( value == this.groupOptions[this.groupOptions.length - 1]) {
                this.groupNumber = 2;
            }
        },
        async saveQuiz() {
            const quiz = new Quiz();
            quiz.date = new Date(),
            quiz.type = this.type;
            quiz.route = this.route;
            quiz.location = this.location ? this.location : null;
            if (this.type == QuizType.INIT) {
                quiz.answers = {
                    edad: this.age,
                    grupo: this.groupType,
                    numeroPersonas: this.groupNumber,
                    sexo: this.gender,
                    nacionalidad: this.nationality,
                    codigoPostal: this.postalCode
                }
            } else {
                quiz.answers = {
                    puntos: this.points,
                    item: this.item
                }
            }
            await quizService.saveQuiz(quiz);
            this.v$.$reset();
            if (this.type == QuizType.INIT) {
                this.$emit("back", true);
            } else {
                this.showFinal = true;
            }
            
        },
        selectPoints(value: number): void {
            this.v$.points.$model = value;
        },
        selectItem(item: string): void {
            this.v$.item.$model = item;
        },
        close(value: boolean): void {
            this.$emit("goTo", value);
        },
        getEmoji(n: number): string {
            return ['😟', '🙁', '😐', '😊', '😍'][n - 1];
        }
    }
})